import ListadoAdmin from './ListadoAdmin';

export default ListadoAdmin;
